/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { MergedCardTransactionTransactionRecordListInner } from './merged-card-transaction-transaction-record-list-inner';

/**
 * 
 * @export
 * @interface MergedCardTransaction
 */
export interface MergedCardTransaction {
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransaction
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransaction
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransaction
     */
    'merchantName': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransaction
     */
    'merchantNameKana': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransaction
     */
    'merchantNameKanji': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransaction
     */
    'mergedMerchantName': string;
    /**
     * 
     * @type {number}
     * @memberof MergedCardTransaction
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof MergedCardTransaction
     */
    'amountFx': number;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransaction
     */
    'currencyCode': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransaction
     */
    'processedAt': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransaction
     */
    'transactionType': MergedCardTransactionTransactionTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof MergedCardTransaction
     */
    'creditSettlement': number;
    /**
     * 
     * @type {Array<MergedCardTransactionTransactionRecordListInner>}
     * @memberof MergedCardTransaction
     */
    'transactionRecordList': Array<MergedCardTransactionTransactionRecordListInner>;
    /**
     * 
     * @type {boolean}
     * @memberof MergedCardTransaction
     */
    'isCleared': boolean;
}

export const MergedCardTransactionTransactionTypeEnum = {
    confirm: 'CONFIRM',
    notConfirm: 'NOT_CONFIRM'
} as const;

export type MergedCardTransactionTransactionTypeEnum = typeof MergedCardTransactionTransactionTypeEnum[keyof typeof MergedCardTransactionTransactionTypeEnum];


